import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=879026e8&scoped=true&"
import script from "./ContactsList.vue?vue&type=script&lang=ts&"
export * from "./ContactsList.vue?vue&type=script&lang=ts&"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=879026e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879026e8",
  null
  
)

export default component.exports